import React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  grid: {
    display: "flex",
    justifyContent: "center",
    margin: "5em auto 2em auto",
  },
}));
const NtkHeader = ({ header }) => {
  const classes = useStyles();
  return (
    <Grid data-testid="ntkHeader" container className={classes.grid}>
      <Typography className={classes.header} color="primary" variant="h1">
        {header}
      </Typography>
    </Grid>
  );
};

export default NtkHeader;
